import moment from "moment";
import React from "react";

const TicketHeader = ({
  ticketId = "",
  type = "",
  subject = "",
  assignee = "",
  priority = "--",
  createadAt,
  lob,
  status,
  dcn
}) => {
  return (
    <div className="flex flex-col space-y-5">
      <div>
        <h1 className="font-28-42-400 poppins-regular">Tickets #{ticketId}</h1>

      </div>
      <div className=" flex py-10 px-4 justify-center flex-col h-106 w-full bg-white-2 border-ticket-header">
        <div className="font-20-30-400 poppins-regular flex">
          <p className="w-96"> Assignee: </p>
          <span className="ml-3">{assignee}</span>
        </div>
        <div className="font-20-30-400 poppins-regular flex">
          <p className="w-96"> Type: </p>
          <span className="ml-3">{type}</span>
        </div>          
        <div className="font-20-30-400 poppins-regular flex">
          <p className="w-96"> Subject: </p>
          <span className="ml-3">{subject}</span>
        </div>                      
        <div className="flex items-center justify-between">
          <div className="flex">
            <p className="w-96 font-20-30-400 poppins-regular"> Status: </p>
            <span className="ml-3 font-20-30-400 poppins-regular">
              {status}
            </span>
          </div>
          <span className="font-18-400-24">
            Created:
            {moment.utc(createadAt).fromNow()}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TicketHeader;
